import Vue from 'vue';
import './plugins/bootstrap-vue';
import 'element-ui/lib/theme-chalk/index.css';
import './components/App.scss';
import * as Sentry from '@sentry/browser';
import { Vue as VueIntegration } from '@sentry/integrations';
import Router from './router';
import { targetsYmOnLinksPage, targetsYmOnAllElements } from './helpers/targets-ym';
import { targetsGAOnAllElements } from './helpers/targets-ga';

import app from './app';
import registerAxios503Interceptor from './utils/axios-503-interceptor';

Sentry.init({
  dsn: 'https://572bd80132c14ab8ab3a1d24dc83f64e@sentry10.boxberry.ru/8',
  integrations: [
    new VueIntegration({
      Vue,
      attachProps: true,
      logErrors: true,
    }),
    new Sentry.Integrations.GlobalHandlers({
      onunhandledrejection: false,
    }),
  ],
});

registerAxios503Interceptor();

/*
 * @TODO Remove this after BOXBERRY-356 debug
 */

// // eslint-disable-next-line
// const axios = require('axios');
//
// axios.post('/errors/503');

Vue.config.productionTip = false;

app.init();

Router();

targetsYmOnLinksPage();
targetsGAOnAllElements();
targetsYmOnAllElements();
